@if (visible()) {
  <span
    class="bdf-pill"
    [class.bdf-pill--sm]="size() === 'sm'"
    [class.bdf-pill--xxs]="size() === 'xxs'"
    [attr.data-state]="effectiveStatus()"
    [appTooltip]="effectiveTooltip()">
    @if (effectiveStatus() === 'running') {
      <app-inline-spinner aria-hidden="true"></app-inline-spinner>
    }
    {{ effectiveText() }}
  </span>
}
